export const FOLLOWED_UP_FROM_PARAM = 'followedUpFrom';
export const FOLLOWED_UP_TILL_PARAM = 'followedUpTill';
export const INCLUDE_FOLLOWED_UP_PARAM = 'includeFollowedUp';
export const ONLY_NEGATIVE_PARAM = 'onlyNegative';